import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-2 px-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "comment",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Bemærkning", -1)
const _hoisted_3 = {
  key: 1,
  class: "py-2 px-6"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-800" }, "Der er ingen mobiliseringer på denne dag.", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "comment",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.remark) = $event)),
              name: "comment",
              placeholder: "Ingen bemærkning",
              class: "block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.remark]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}